angular.module('main').directive('btnView', () => ({
	restrict: 'AE',
	scope: {
		text: '@snText',
		isLink: '@',
		linkHref: '@',
		target: '@',
		classes: '@customClasses'
	},
	template(elem, attr) {
		let template = '';
		window.attr = attr;

		if (attr.isLink === 'true' && attr.linkHref) {
			template = attr.target
				? '<a ng-href="{{linkHref}}" target="{{target}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>'
				: '<a ng-href="{{linkHref}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>';
		} else {
			template = attr.target
				? '<a ng-href="{{linkHref}}" target="{{target}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>'
				: '<a ng-href="{{linkHref}}" class="btn btn-default" ng-class="classes"><i class="fi fi-view"></i>{{text}}</a>';
		}

		return template;
	},
	replace: true,
	transclude: true,
	link(scope) {
		scope.text = scope.text || 'View';
	}
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnView.js